import { combineReducers } from 'redux'

import deleteNode from './users/delete'
import get from './users/get'
import list from './users/list'
import post from './users/post'
import put from './users/put'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/users.js